import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { StateProvider } from './state-management/state-provider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <StateProvider>
      <App />
    </StateProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass an analytics function.
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
